import { ChangeEvent } from 'react';
import { twJoin } from 'tailwind-merge';

interface Props {
    name: string;
    defaultChecked?: boolean;
    onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    ariaLabel?: string;
}

export function SwitchInput({ name, defaultChecked, onChange, disabled = false, ariaLabel }: Props) {
    return (
        <label
            htmlFor={`switch-${name}`}
            aria-label={ariaLabel}
            className={twJoin(
                'cursor-pointer outline-offset-2 has-[input:focus-visible]:outline',
                'w-14 rounded-full p-1 transition-colors',
                'bg-neutral-200 has-[:checked]:bg-primary-500',
                disabled && 'cursor-not-allowed opacity-50',
            )}>
            <input
                id={`switch-${name}`}
                className="peer sr-only absolute"
                type="checkbox"
                value="true"
                defaultChecked={defaultChecked}
                onChange={onChange}
                disabled={disabled}
            />
            <div
                className={twJoin(
                    'size-6 translate-x-0 rounded-full bg-white',
                    'transition-transform peer-checked:translate-x-full',
                )}
            />
            <span className="sr-only">{name}</span>
        </label>
    );
}
